var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button-toolbar',[_c('b-button-group',{class:{
    'd-flex flex-grow-1 rounded': true,
    [`px-0 bg-search${_vm.dark ? '-dark' : ''}`]: !_vm.expanded,
    [`mx-0`]: _vm.expanded,
  }},_vm._l((_vm.sources),function(source){return _c('SourceSelectorButton',{key:source,attrs:{"nav":_vm.nav,"text":_vm.$t(_vm.getName(source)),"source":source,"active":source === _vm.selected,"expanded":_vm.expanded,"icon":_vm.$t(`${_vm.getName(source)}-icon`),"variant":_vm.variant,"toggleable":_vm.toggleable},on:{"select":function($event){return _vm.$emit('select', $event)},"expand":function($event){return _vm.$emit('expand', $event)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }